// Static JSON stub for the videoKey -> YouTube URL mapping (see project_commandsearch_video_idea memory).
// Shared by CommandPalette.js and AlertModal.js's "Watch how" affordance.
const HELP_VIDEO_MAP_URL = "/Data/HelpVideoMap.json";

let cachedMap = null;
let pendingFetch = null;

export const getHelpVideoMap = () => {
  if (cachedMap) return Promise.resolve(cachedMap);
  if (!pendingFetch) {
    // This file is served with cache-control: max-age=3600 — fine in
    // general, but it means a browser can keep serving a stale copy for
    // up to an hour after a new videoKey is added, independent of this
    // module's own cachedMap (which only avoids refetching within a
    // single page session). A cache-busting query param makes each
    // fetch a distinct URL as far as the browser cache is concerned, so
    // it always hits the network for the current file. Matches mobile's
    // identical fix in andiamo-places' HelpVideoMap.js. Found 2026-09-17.
    pendingFetch = fetch(`${HELP_VIDEO_MAP_URL}?_=${Date.now()}`)
      .then((r) => r.json())
      .then((data) => {
        cachedMap = data;
        return data;
      })
      .catch(() => ({}));
  }
  return pendingFetch;
};
